<template>
  <div class="container">
    <content-header :data="[{text:'文章一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <router-link to="/article/new">
            <el-button type="primary"> 添加</el-button>
          </router-link>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="关键词"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="ID"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题">
          </el-table-column>
          <el-table-column
            label="封面图">
            <template slot-scope="scope">
            <img style="width:40px;height:40px":src="domainPic + scope.row.cover_url" v-if="scope.row.cover_url"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="thumbup_count"
            label="点赞数">
          </el-table-column>
          <el-table-column
            prop="comment_count"
            label="评论数">
          </el-table-column>
          <el-table-column
            label="置顶">
            <template slot-scope="scope">
              <span>{{scope.row.is_topmost==0 ? '否':'是'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="topmostHandle(scope)" type="text" size="small" >{{ scope.row.is_topmost == 1 ? '取消置顶' : '置顶' }}</el-button>
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改文章' : '添加文章'" :visible.sync="isObjShow" width="100%">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="title" label="标题" :label-width="formLabelWidth">
              <el-input name="title" v-model="curObj.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="category_id" label="分类" :label-width="formLabelWidth">
              <el-select v-model="curObj.category_id" clearable value-key="id" placeholder="请选择类型">
                <el-option
                  v-for="item in categoryIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cover_url" label="题图" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                :headers = "uploadHeader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="curObj.cover_url" :src="domainPic + curObj.cover_url" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item prop="content" label="内容" :label-width="formLabelWidth">
              <vue-ueditor-wrap ref="ueditor" v-model="curObj.content"></vue-ueditor-wrap>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import sessionstorage from 'utils/sessionstorage'
  import urls from 'config/urls'
  import ArticleModel from 'models/article'

  export default {
    components: {
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        uploadUrl: constants.basic.domain + urls.file.upload,
        uploadHeader: {},
        keywords: '',
        tableData: [],
        isObjShow: false,
        categoryIds: [],
        curObj: {
          id: '',
          title: '',
          category_id: '',
          cover_url: '',
          content: '',
        },
        formLabelWidth: '120px',
        curObjRules: {
          title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        },
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      sessionstorage.getItem('token').then(token => {
        if (!token) return
        this.uploadHeader = {Authorization: 'Bearer ' + token}
      })
      //
      this.getObjList()
      ArticleModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        // console.log(res)
        this.categoryIds = res.item_list
      })
    },
    methods: {
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadPhotoSuccess (response, file, fileList) {
        this.curObj.cover_url = response
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isPic && isLt2M
      },
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        console.log(_opts)
        //
        ArticleModel.find(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            ArticleModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      topmostHandle (item) {
        this.$confirm(!item.row.is_topmost ? '确认置顶？' : '取消置顶?')
          .then(_ => {
            ArticleModel.setTopmost({
              id: item.row.id,
              is_topmost: item.row.is_topmost === 0 ? 1 : 0
            }).then(() => {
              item.row.is_topmost = (item.row.is_topmost === 0 ? 1 : 0)
              this.$message({ message: item.row.is_topmost === 1 ? '置顶成功' : '已取消置顶', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          title: '',
          category_id: '',
          cover_url: '',
          content: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        ArticleModel.create(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.$router.push({
          name: 'article.new',
          query: { id: item.row.id }
        })
      },
      editHandle () {
        ArticleModel.update(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block

</style>



// WEBPACK FOOTER //
// src/views/Article.vue